<!-- Кнопка архивирования и восстановления записи в едином стиле проекта. -->
<template>
  <base-button
    v-bind="$attrs"
    type="button"
    :variant="archived ? 'secondary' : 'danger'"
    :icon="iconName"
    class="archive-restore-btn"
    :disabled="disabled || loading"
    @click="showDialog = true"
  >
    {{ buttonLabel }}
  </base-button>

  <BaseDialog
    :visible="showDialog"
    :title="dialogTitle"
    :message="dialogMessage"
    :actions="dialogActions"
    @action="handleDialogAction"
  />
</template>

<script>
export default {
  name: "BaseArchiveRestoreButton",
  inheritAttrs: false,

  props: {
    archived: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    archiveTitle: {
      type: String,
      default: "Архивировать запись?",
    },
    archiveMessage: {
      type: String,
      default: "Запись будет убрана из обычной работы. Ее можно будет восстановить из архива.",
    },
    restoreTitle: {
      type: String,
      default: "Восстановить запись?",
    },
    restoreMessage: {
      type: String,
      default: "Запись снова появится в обычной работе.",
    },
  },

  emits: ["click"],

  data() {
    return {
      showDialog: false,
    };
  },

  computed: {
    iconName() {
      return this.archived ? "restore" : "trash";
    },

    buttonLabel() {
      if (this.loading) {
        return this.archived ? "Восстановление..." : "Архивация...";
      }

      return this.archived ? "Восстановить" : "Архивировать";
    },

    dialogTitle() {
      return this.archived ? this.restoreTitle : this.archiveTitle;
    },

    dialogMessage() {
      return this.archived ? this.restoreMessage : this.archiveMessage;
    },

    dialogActions() {
      return [
        {
          key: "confirm",
          label: this.archived ? "Восстановить" : "Архивировать",
          type: this.archived ? "primary" : "danger",
        },
        {
          key: "close",
          label: "Отмена",
          type: "secondary",
        },
      ];
    },
  },

  methods: {
    handleDialogAction(actionKey) {
      this.showDialog = false;
      if (actionKey !== "confirm") return;

      this.$emit("click");
    },
  },
};
</script>
